// extracted by mini-css-extract-plugin
export var actionButton = "_r1-0";
export var actionMenuContainer = "_r1-i";
export var bubble = "_r1-2";
export var bubbleActionMenu = "_r1-j";
export var bubbleContext = "_r1-6";
export var bubbleItems = "_r1-7";
export var customer = "_r1-3";
export var divider = "_r1-8";
export var fileList = "_r1-9";
export var hiddenComment = "_r1-o";
export var infoAbove = "_r1-a";
export var internal = "_r1-4";
export var lightActionButton = "_r1-1";
export var link = "_r1-b";
export var merchant = "_r1-5";
export var message = "_r1-c";
export var profilePicture = "_r1-e";
export var quillToolbarContainer = "_r1-f";
export var senderDate = "_r1-g";
export var senderDateCustomer = "_r1-h";
export var senderName = "_r1-d";
export var time = "_r1-k";
export var uploadedImage = "_r1-l";
export var username = "_r1-m";
export var xsmall = "_r1-n";